var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfinity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 16,
    viewBox: "0 0 30 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7903 15.616C19.9103 15.616 16.8383 14.144 14.8542 10.816C12.9343 14.144 9.54225 15.616 6.91825 15.616C3.01425 15.616 0.13425 12.288 0.13425 8.128C0.13425 3.968 3.01425 0.703999 7.11025 0.703999C10.0543 0.703999 12.7423 2.304 15.1103 6.144C17.5423 2.304 20.0383 0.703999 22.9823 0.703999C27.0143 0.703999 29.8943 3.968 29.8943 8.128C29.8943 12.288 27.2063 15.616 22.7903 15.616ZM22.9183 13.312C25.6063 13.312 27.3343 10.944 27.3343 8.128C27.3343 5.312 25.6063 3.008 22.9183 3.008C20.2943 3.008 17.8623 5.312 16.2623 8.384C17.8623 11.136 20.4223 13.312 22.9183 13.312ZM7.11025 13.312C9.60625 13.312 12.1663 11.136 13.7663 8.384C12.1663 5.312 9.73425 3.008 7.11025 3.008C4.42225 3.008 2.69425 5.312 2.69425 8.128C2.69425 10.944 4.42225 13.312 7.11025 13.312Z",
    fill: "#025F39"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfinity);
export default __webpack_public_path__ + "static/media/infinity.8bd7e221424e637c5334ee0f0fc63da8.svg";
export { ForwardRef as ReactComponent };